<div mat-dialog-title style="padding: 10px; color: #FFF; background-color:#1579ab;">
  <div class="d-flex justify-content-between">
      Copy Checklist Response
      <i class="fa fa-times-circle pull-right" style="font-size: 24px;" (click)="closeDialog()" aria-hidden="true"></i>
  </div>
</div>
<div mat-dialog-content>
  <div class="row m-0">
      <div class="col-12 p-0">
          <div [ngClass]="{'kgrid-fullscreen' : enableFullscreen }">
              <kendo-grid [kendoGridBinding]="Response" [sortable]="true" [resizable]="true" [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [pageable]="true" id="grvEDMMemberList">
                  <ng-template kendoPagerTemplate>
                      <div class="k-pager-left">
                          <kendo-pager-info></kendo-pager-info>
                      </div>
                      <div class="k-pager-right">
                          <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                          <kendo-pager-input></kendo-pager-input>
                          <kendo-pager-next-buttons></kendo-pager-next-buttons>
                      </div>
                  </ng-template>
                  <ng-template kendoGridToolbarTemplate>
                      <div class="k-grid-toolbar-content d-flex">
                          <div class="flex-grow-1 mat-panel-headerbar"></div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="pagination-container">
                              <p id="lblShowDetails">Show</p>
                              <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                              </kendo-pager-page-sizes>
                              <span>Items</span>
                          </div>
                          <div class="divider-container d-none d-md-block" id="imgDivider">
                              <span></span>
                          </div>
                          <div class="icons-container">
                              <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                              <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                  <div class="icon-wrap" (click)="toggleFilter()">
                                      <i class="fa fa-filter" title="Filter" aria-hidden="true"></i>
                                      <span class="list-icon-name">Filter</span>
                                  </div>
                                  <div class="icon-wrap" (click)="toggleFullscreen()">
                                      <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                                      <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                                  </div>
                              </div>
                              <div class="divider-container"><span></span></div>
                          </div>
                      </div>
                  </ng-template>
                  <kendo-grid-column title="Check List Name" field="clDescription" width="100">
                  </kendo-grid-column>
                  <kendo-grid-column title="SuccessMessage" field="successMessage" width="100">
                  </kendo-grid-column>
              </kendo-grid>
          </div>
      </div>
  </div>
</div>